(function() {
  'use strict';

  function centerActiveBullet(paginationContainer, activeBullet) {
    if (!paginationContainer || !activeBullet) {
      console.log('centerActiveBullet: Missing container or bullet', paginationContainer, activeBullet);
      return;
    }

    const containerRect = paginationContainer.getBoundingClientRect();
    const bulletRect = activeBullet.getBoundingClientRect();
    const containerScrollLeft = paginationContainer.scrollLeft;
    
    const containerCenter = containerRect.width / 2;
    
    const bulletLeft = bulletRect.left - containerRect.left + containerScrollLeft;
    const bulletWidth = bulletRect.width;
    const bulletCenter = bulletLeft + (bulletWidth / 2);
    
    const scrollTarget = bulletCenter - containerCenter;
    
    console.log('Scrolling pagination to center bullet:', {
      containerWidth: containerRect.width,
      bulletLeft: bulletLeft,
      bulletWidth: bulletWidth,
      scrollTarget: scrollTarget
    });
    
    paginationContainer.scrollTo({
      left: scrollTarget,
      behavior: 'smooth'
    });
  }

  function initPaginationScroll(blazeSliderInstance) {
    if (!blazeSliderInstance) {
      console.log('BlazeSlider instance not found');
      return;
    }

    // Encontrar o elemento de paginação do BlazeSlider
    const blazeContainer = blazeSliderInstance.el;
    
    // Procurar primeiro pelo wrapper, depois pela paginação direta
    let paginationContainer = blazeContainer.querySelector('.blaze-pagination-wrapper');
    let paginationEl = null;
    
    if (paginationContainer) {
      paginationEl = paginationContainer.querySelector('.blaze-pagination');
    } else {
      // Fallback para paginação sem wrapper
      paginationContainer = blazeContainer.querySelector('.blaze-pagination');
      paginationEl = paginationContainer;
    }
    
    if (!paginationContainer || !paginationEl) {
      console.log('Pagination element not found in', blazeContainer);
      return;
    }

    // Verificar se já foi inicializado para evitar duplicação
    if (paginationContainer.dataset.scrollInitialized === 'true') {
      console.log('Pagination scroll already initialized');
      return;
    }
    paginationContainer.dataset.scrollInitialized = 'true';
    console.log('Initializing BlazeSlider pagination scroll for', paginationContainer, paginationEl);

    // Escutar mudanças de slide do BlazeSlider
    blazeSliderInstance.onSlide((slideIndex, firstVisibleSlide) => {
      setTimeout(function() {
        // Procurar pelo bullet ativo usando diferentes seletores possíveis
        const activeBullet = paginationEl.querySelector('.active') || 
                            paginationEl.querySelector('.blaze-pagination-button.active') ||
                            paginationEl.querySelector('button.active') ||
                            paginationEl.querySelector(`[data-slide-to="${slideIndex}"]`);
        if (activeBullet) {
          centerActiveBullet(paginationContainer, activeBullet);
        }
      }, 50);
    });

    // Escutar cliques na paginação
    paginationEl.addEventListener('click', function(e) {
      // No BlazeSlider, os bullets podem ter classes diferentes
      if (e.target.matches('[data-slide-to]') || 
          e.target.closest('[data-slide-to]') ||
          e.target.matches('.blaze-pagination-button') ||
          e.target.matches('button')) {
        setTimeout(function() {
          const activeBullet = paginationEl.querySelector('.active') || 
                              paginationEl.querySelector('.blaze-pagination-button.active') ||
                              paginationEl.querySelector('button.active');
          if (activeBullet) {
            centerActiveBullet(paginationContainer, activeBullet);
          }
        }, 50);
      }
    });

    // Centralizar o bullet ativo inicial
    setTimeout(function() {
      const activeBullet = paginationEl.querySelector('.active') || 
                          paginationEl.querySelector('.blaze-pagination-button.active') ||
                          paginationEl.querySelector('button.active') ||
                          paginationEl.querySelector('button:first-child');
      if (activeBullet) {
        centerActiveBullet(paginationContainer, activeBullet);
      }
    }, 100);
  }

  // Função global para inicialização manual
  window.initBlazePaginationScroll = function(blazeSliderInstance) {
    initPaginationScroll(blazeSliderInstance);
  };

  // Auto-inicialização
  function autoInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', autoInit);
      return;
    }

    // Procurar por sliders BlazeSlider com paginação
    const blazeContainers = document.querySelectorAll('.blaze-container-gallery, .blaze__product-images, .blaze-slider');
    
    blazeContainers.forEach(function(container) {
      const paginationWrapper = container.querySelector('.blaze-pagination-wrapper');
      const paginationEl = container.querySelector('.blaze-pagination');
      
      if (paginationWrapper || paginationEl) {
        // Tentar encontrar a instância do slider
        if (container.blazeSlider) {
          initPaginationScroll(container.blazeSlider);
        } else {
          // Se não encontrou a instância, tentar novamente após um delay
          setTimeout(function() {
            if (container.blazeSlider) {
              initPaginationScroll(container.blazeSlider);
            }
          }, 500);
        }
      }
    });
  }
  
  // Executar auto-inicialização
  autoInit();

  // Observer para detectar novos sliders adicionados dinamicamente
  if (window.MutationObserver) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            const blazeContainers = node.querySelectorAll 
              ? node.querySelectorAll('.blaze-container-gallery, .blaze__product-images')
              : [];
            
            blazeContainers.forEach(function(container) {
              const paginationEl = container.querySelector('.blaze-pagination');
              
              if (paginationEl && container.blazeSlider) {
                initPaginationScroll(container.blazeSlider);
              }
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Função específica para o produto (PDP)
  window.initProductPaginationScroll = function() {
    const productSlider = document.querySelector('.blaze__product-images');
    if (productSlider && productSlider.blazeSlider) {
      initPaginationScroll(productSlider.blazeSlider);
    }
    
    // Também inicializar para o slider da galeria principal
    const gallerySlider = document.querySelector('.gallery-main-slider');
    if (gallerySlider && gallerySlider.blazeSlider) {
      initPaginationScroll(gallerySlider.blazeSlider);
    }
    
    // Procurar por qualquer container com wrapper de paginação
    const containersWithWrapper = document.querySelectorAll('.blaze-pagination-wrapper');
    containersWithWrapper.forEach(function(wrapper) {
      const container = wrapper.closest('.blaze-container-gallery, .blaze__product-images, .blaze-slider');
      if (container && container.blazeSlider) {
        initPaginationScroll(container.blazeSlider);
      }
    });
  };

})();
